export const resources = {
  junior: {
    macos: [
      { name: 'UI Design Fundamentals', url: 'https://www.interaction-design.org/literature/topics/ui-design', type: 'fundamentals' },
      { name: 'Visual Design Principles', url: 'https://www.nngroup.com/articles/visual-design-basics/', type: 'principles' },
      { name: 'Color Theory for UI', url: 'https://www.smashingmagazine.com/2010/01/color-theory-for-designers-part-1-the-meaning-of-color/', type: 'color' },
      { name: 'Typography in UI Design', url: 'https://www.smashingmagazine.com/2011/03/how-to-choose-a-typeface/', type: 'typography' }
    ],
    windows: [
      { name: 'Microsoft Fluent Design System', url: 'https://www.microsoft.com/design/fluent/', type: 'design-system' },
      { name: 'Windows UI Guidelines', url: 'https://docs.microsoft.com/en-us/windows/apps/design/', type: 'guidelines' },
      { name: 'Adobe Creative Suite for UI', url: 'https://www.adobe.com/products/photoshop.html', type: 'tools' },
      { name: 'Figma for Windows', url: 'https://www.figma.com/', type: 'tools' }
    ],
    linux: [
      { name: 'Open Source UI Design', url: 'https://github.com/topics/ui-design', type: 'open-source' },
      { name: 'GIMP for UI Design', url: 'https://www.gimp.org/tutorials/', type: 'tools' },
      { name: 'Inkscape UI Elements', url: 'https://inkscape.org/learn/tutorials/', type: 'tools' },
      { name: 'Web-based Design Tools', url: 'https://www.figma.com/', type: 'web-tools' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Visual Design', url: 'https://www.smashingmagazine.com/category/visual-design/', type: 'advanced' },
      { name: 'UI Animation Principles', url: 'https://material.io/design/motion/', type: 'animation' },
      { name: 'Design System Creation', url: 'https://designsystemsrepo.com/', type: 'design-systems' },
      { name: 'Advanced Sketch Techniques', url: 'https://www.sketch.com/docs/', type: 'tools' }
    ],
    windows: [
      { name: 'Advanced Adobe XD', url: 'https://www.adobe.com/products/xd.html', type: 'tools' },
      { name: 'Microsoft Design Toolkit', url: 'https://www.microsoft.com/design/toolkit/', type: 'toolkit' },
      { name: 'Windows App Design Patterns', url: 'https://docs.microsoft.com/en-us/windows/apps/design/controls/', type: 'patterns' },
      { name: 'Power Platform UI Design', url: 'https://powerapps.microsoft.com/en-us/blog/category/design/', type: 'platform' }
    ],
    linux: [
      { name: 'Advanced Open Source Design', url: 'https://opensourcedesign.net/', type: 'community' },
      { name: 'Blender UI Design', url: 'https://www.blender.org/', type: 'tools' },
      { name: 'Web Component Design', url: 'https://web.dev/web-components/', type: 'web-components' },
      { name: 'CSS Design Systems', url: 'https://css-tricks.com/design-systems/', type: 'css' }
    ]
  },
  senior: {
    macos: [
      { name: 'UI Design Leadership', url: 'https://www.designbetter.co/design-leadership-handbook', type: 'leadership' },
      { name: 'Advanced Design Systems', url: 'https://atomicdesign.bradfrost.com/', type: 'systems' },
      { name: 'Design Operations', url: 'https://www.designbetter.co/design-ops-handbook', type: 'operations' },
      { name: 'UI Innovation Trends', url: 'https://trends.uxdesign.cc/', type: 'trends' }
    ],
    windows: [
      { name: 'Enterprise UI Strategy', url: 'https://www.microsoft.com/design/', type: 'enterprise' },
      { name: 'Scalable Design Systems', url: 'https://docs.microsoft.com/en-us/azure/architecture/guide/design-principles/', type: 'scaling' },
      { name: 'AI in UI Design', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/', type: 'ai-design' },
      { name: 'Cross-Platform UI', url: 'https://docs.microsoft.com/en-us/dotnet/maui/', type: 'cross-platform' }
    ],
    linux: [
      { name: 'Open Source Design Leadership', url: 'https://github.com/opensourcedesign', type: 'leadership' },
      { name: 'UI Automation Systems', url: 'https://github.com/topics/design-automation', type: 'automation' },
      { name: 'Advanced Web UI', url: 'https://web.dev/', type: 'web-ui' },
      { name: 'UI Performance Optimization', url: 'https://developers.google.com/web/fundamentals/performance', type: 'performance' }
    ]
  }
};
